export default __webpack_public_path__ + "static/media/active-level-1.22c070a3.svg";